import type { Relation } from 'state/selectedTemplate/selectedTemplateStore';
import { getDisplayName } from 'utils/names';

/**
 * Label for a relation as read from one of its ends: `displayNames` from the source side,
 * `reverseDisplayNames` from the target side.
 *
 * Shared by everything that names a relation to the user — the graph's focused→pill edge and a grid
 * scoped to one relation's members — so a blueprint with no matching display name falls back to the
 * technical name identically on both surfaces, instead of the same relation being labelled two ways.
 */
export function relationLabel(relation: Relation, isReverse: boolean): string {
  return getDisplayName(isReverse ? relation.reverseDisplayNames : relation.displayNames, {
    fallbackName: relation.technicalName
  });
}
